import React from 'react';
import Login from '../auth/Login';
import BmiCalculator from '../pages/BmiCalculator';
import TraillAssessment from '../pages/TraillAssessment';
import TargetResult from '../pages/TargetResult';
import GameScreen from '../pages/Game';
import HomeScreen from '../pages/Home';
import BuddyTournamentCreate from '../pages/BuddyTournamentCreate';
import BuddyTournamentJoin from '../pages/BuddyTournamentJoin';
import VersusScreen from '../pages/Versus';
import ProfileScreen from '../pages/Profile';
import DetailedScreen from '../pages/Detailed';
import SettingScreen from '../pages/Setting';
import Tournament from '../pages/Tournament';
import Achievement from '../pages/Achivement';
import Dailytarget from '../pages/DailyTarget';
import Createprofile from '../pages/CreateProfile';
import PrivateRoute from '../routes/privateroute';
import Account from '../pages/Account';
import { Route, Routes } from 'react-router-dom';
import { LOGIN, BMICALCULATOR, TARGETRESULT, TRAILASSESMENT, CREATEPROFILE, GAME, GAMEPASS, PROFILE, DETAILED, SETTING, BUDDYTOURNAMENTCREATE, BUDDYTOURNAMENTJOIN, VERSUS, TOURNAMENT, ACHIEVEMENT, DAILYTARGET, ACCOUNT, PAYMENTSUCCESS, VOICECHAT, ONBOARDING, REAL_BADGE, MEMBERSHIP, PIGGYBANK, REGISTER, VERIFYOTP, FORGOTPASSWORD, HOME, CONTACT_US, LEADERBOARD } from '../helpers/Constant';
import PaymentSuccess from '../pages/PaymentSuccess';
import VoiceChat from '../pages/VoiceChat';
import OnBoarding from '../pages/onBoarding';
import RealBadge from '../pages/RealBadge';
import Membership from '../pages/Membership';
import PiggyBank from '../pages/PiggyBank';
import GamePass from '../pages/GamePass';
import Register from '../auth/Register';
import VerifyOtp from '../auth/VerifyOtp';
import ForgotPassword from '../auth/ForgotPassword';
import Splash from '../pages/SplashScreen';
import ContactUs from '../pages/ContactUs/ContactUs';
import Leaderboard from '../pages/Leaderboard';


const HomeRoutes = () => {
    return (
        <Routes>
            <Route path={`/`} element={<Splash />} />
            <Route path={`/${LOGIN}`} element={<Login />} />
            <Route path={`/${ONBOARDING}`} element={<OnBoarding />} />
            <Route path={`/${REGISTER}`} element={<Register />} />
            <Route path={`/${VERIFYOTP}`} element={<VerifyOtp />} />
            <Route path={`/${FORGOTPASSWORD}`} element={<ForgotPassword />} />
            <Route element={< PrivateRoute />}>
                <Route path={`/${BMICALCULATOR}`} element={<BmiCalculator />} />
                <Route path={`/${TARGETRESULT}`} element={<TargetResult />} />
                <Route path={`/${TRAILASSESMENT}`} element={<TraillAssessment />} />
                <Route path={`/${CREATEPROFILE}`} element={<Createprofile />} />
                <Route path={`/${HOME}`} element={<HomeScreen />} />
                <Route path={`/${GAME}`} element={<GameScreen />} />
                <Route path={`/${REAL_BADGE}`} element={<RealBadge />} />
                <Route path={`/${PROFILE}`} element={<ProfileScreen />} />
                <Route path={`/${DETAILED}`} element={<DetailedScreen />} />
                <Route path={`/${SETTING}`} element={<SettingScreen />} />
                <Route path={`/${BUDDYTOURNAMENTCREATE}`} element={<BuddyTournamentCreate />} />
                <Route path={`/${VERSUS}`} element={<VersusScreen />} />
                <Route path={`/${TOURNAMENT}`} element={<Tournament />} />
                <Route path={`/${ACHIEVEMENT}`} element={<Achievement />} />
                <Route path={`/${DAILYTARGET}`} element={<Dailytarget />} />
                <Route path={`/${ACCOUNT}`} element={<Account />} />
                <Route path={`/${PAYMENTSUCCESS}`} element={<PaymentSuccess />} />
                <Route path={`/${MEMBERSHIP}`} element={<Membership />} />
                <Route path={`/${PIGGYBANK}`} element={<PiggyBank />} />
                <Route path={`/${GAMEPASS}`} element={<GamePass />} />
                <Route path={`/${LEADERBOARD}`} element={<Leaderboard />} />
                <Route path={`/${CONTACT_US}`} element={<ContactUs />} />
            </Route>
            <Route path={`/${BUDDYTOURNAMENTJOIN}`} element={<BuddyTournamentJoin />} />
            <Route path={`/${VOICECHAT}`} element={<VoiceChat />} />
        </Routes>
    );
}

export default HomeRoutes;